function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useReducer } from 'react';
export var Portal;
(function (Portal) {
  let active = false;
  let dispatch;
  const reducer = (state, action) => {
    const payload = action.payload;
    switch (action.type) {
      case 'add':
        {
          const index = state.findIndex(item => item.id === payload.id);
          if (index >= 0) {
            state[index] = payload;
            return [...state];
          }
          return [...state, payload];
        }
      case 'remove':
        {
          const index = state.findIndex(item => item.id === payload.id);
          if (index >= 0) {
            const result = [...state];
            result.splice(index, 1);
            return result;
          }
          break;
        }
      default:
        {
          break;
        }
    }
    return state;
  };
  function connect(id, portal) {
    if (active) {
      dispatch({
        type: 'add',
        payload: {
          id,
          portal
        }
      });
    }
  }
  Portal.connect = connect;
  function disconnect(id) {
    if (active) {
      dispatch({
        type: 'remove',
        payload: {
          id
        }
      });
    }
  }
  Portal.disconnect = disconnect;
  function isActive() {
    return active;
  }
  Portal.isActive = isActive;
  function getProvider() {
    // eslint-disable-next-line react/display-name
    return () => {
      active = true;
      const _useReducer = useReducer(reducer, []),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        items = _useReducer2[0],
        mutate = _useReducer2[1];
      dispatch = mutate;
      // eslint-disable-next-line react/no-children-prop
      return /*#__PURE__*/React.createElement(React.Fragment, {
        children: items.map(item => item.portal)
      });
    };
  }
  Portal.getProvider = getProvider;
})(Portal || (Portal = {}));